import config from "../config";
import { PsrCaptureProfile } from "../Model/CaptureProfile";
import { sendGetRequest, sendPostRequest } from "./../Utility/FetchUtils";

class PsrCameraApi {
  static BASE_URL = config.SERVICE_URL + "/PsrCamera";

  static setCaptureProfile(psrIdentifier: string, psrCameraId: number, captureProfile: PsrCaptureProfile) {
    const url = this.BASE_URL + `/${psrIdentifier}/${psrCameraId}/capture-profile`;
    return sendPostRequest(url, captureProfile);
  }

  // static getCaptureProfile(psrIdentifier: string, psrCameraId: number) {
  //   const url = this.BASE_URL + `/${psrIdentifier}/${psrCameraId}/capture-profile`;
  //   return sendGetRequest<PsrCaptureProfile>(url);
  // }

  static doAutoFocus(psrIdentifier: string, psrCameraId: number){
    const url = this.BASE_URL + `/${psrIdentifier}/${psrCameraId}/:auto-focus`;
    return sendPostRequest(url);
  }

  static SetStreaming(psrIdentifier: string, psrCameraId: number, enabled:boolean){
    const url = this.BASE_URL + `/${psrIdentifier}/${psrCameraId}/streaming/${enabled}`;
    return sendPostRequest(url);
  }

  static SetFiducialMarkerDetection(psrIdentifier: string, psrCameraId: number, enabled:boolean){
    const url = this.BASE_URL + `/${psrIdentifier}/${psrCameraId}/fiducial-marker-detection/${enabled}`;
    return sendPostRequest(url);
  }

  static SetBarcodeDetection(psrIdentifier: string, psrCameraId: number, enabled:boolean){
    const url = this.BASE_URL + `/${psrIdentifier}/${psrCameraId}/barcode-detection/${enabled}`;
    return sendPostRequest(url);
  }



}

export default PsrCameraApi;
